export const beaconAssignmentOptionsArray = [
  { value: 'all', label: 'All', default: true, order: 0 },
  { value: 'assigned', label: 'Asset assigned', default: false, order: 1 },
  { value: 'unassigned', label: 'Asset not assigned', default: false, order: 2 },
];

export const menuOptionsAssigned = [
  { value: 'asset_id', label: 'Asset ID' },
  { value: 'beacon_id', label: 'Beacon ID' },
  { value: 'source', label: 'Source' },
];

export const menuOptionsAssetNotAssigned = [
  { value: 'beacon_id', label: 'Beacon ID' },
  { value: 'source', label: 'Source' },
];
